module.exports = __webpack_public_path__ + "img/mq.cd338e46.svg";